import { call, select } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';

import { selectRouteParams } from 'selectors/general';
import { reportsSchedule as reportsScheduleEntity } from 'store/saga/entities/bound';

export function* handleRouteEnter(dependencies) {
  const { scheduleId } = yield select(selectRouteParams);
  yield call(fetchEntityIfNeeded, reportsScheduleEntity, [dependencies, scheduleId]);
}
